const cliColors = {
    Reset: '\x1b[0m',
    Bright: '\x1b[1m',
    Dim: '\x1b[2m',
    Underscore: '\x1b[4m',
    Blink: '\x1b[5m',
    Reverse: '\x1b[7m',
    Hidden: '\x1b[8m',

    FgBlack: '\x1b[30m',
    FgRed: '\x1b[31m',
    FgGreen: '\x1b[32m',
    FgYellow: '\x1b[33m',
    FgBlue: '\x1b[34m',
    FgMagenta: '\x1b[35m',
    FgCyan: '\x1b[36m',
    FgWhite: '\x1b[37m',

    BgBlack: '\x1b[40m',
    BgRed: '\x1b[41m',
    BgGreen: '\x1b[42m',
    BgYellow: '\x1b[43m',
    BgBlue: '\x1b[44m',
    BgMagenta: '\x1b[45m',
    BgCyan: '\x1b[46m',
    BgWhite: '\x1b[47m'
};

type CliColor = keyof typeof cliColors;

const getLogTimestamp = (): string => {
    const now = new Date();
    const M = now.toLocaleString('default', { month: 'short' });
    const d = now.getDate();
    const H = now.getHours();
    const m = now.getMinutes();
    const s = now.getSeconds();

    return `[${M} ${d} ${H}:${m}:${s}]`;
};

/**
 * This is a simple way to overload the console functions to add a timestamp in the logs
 */
export const debug = (...rest: unknown[]) => {
    const shouldLog = process.env.DEBUG === 'true';
    if (!shouldLog) {
        return;
    }
    console.log(colorizeText(getLogTimestamp(), 'FgBlue'), ...rest);
};

export const colorizeText = (text: string, color: CliColor) => {
    return `${cliColors[color]}${text}${cliColors.Reset}`;
};
